import React, { useCallback } from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectProps,
    FormHelperText,
} from '@mui/material';
import { DropdownOption } from 'Interfaces/Dropdown/SelectDropdownInterfaces';

type DropdownProps = SelectProps & {
    label?: string;
    options: DropdownOption[];
    placeholder?: string;
    helperText?: string;
};

const Dropdown: React.FC<DropdownProps> = ({
    label = '',
    options,
    value,
    placeholder,
    onChange,
    fullWidth,
    helperText,
    ...rest
}) => {
    const renderMenuItem = useCallback(
        ({ label, value }: DropdownOption) => (
            <MenuItem key={value} value={value}>
                {label}
            </MenuItem>
        ),
        [],
    );

    return (
        <FormControl fullWidth={fullWidth}>
            <InputLabel shrink>{label}</InputLabel>
            <Select value={value} label={label} onChange={onChange} {...rest}>
                {placeholder && (
                    <MenuItem disabled value="">
                        {placeholder}
                    </MenuItem>
                )}
                {options.map(renderMenuItem)}
            </Select>
            {helperText && (
                <FormHelperText style={{ margin: '3px 14px 0px' }}>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default Dropdown;
